import styled from "styled-components";

export const Body = styled.div`
    
`;

export const Main = styled.div`
    padding: 6px 16px;
    border-radius: 8px;
    background-color: #e9ecf2;
    width: 100%;

    label{
        font-size: 11px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.18;
        letter-spacing: normal;
        text-align: left;
        color: #6b7384;
        margin-bottom: 0px;
        display: block;
    }

    textarea{
        border: none;
        background-color: #e9ecf2;
        width: 100%;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: normal;
        text-align: left;
        color: ${props => props.disabled ? "rgba(0, 0, 0, 0.25)" : "#262e3e"};
        transition: all 0.4s ease-in-out;
        border-bottom: 1px solid #e9ecf2 ;
        cursor: ${props => props.disabled ? "not-allowed" : "unset"};
    }

    textarea:active,
    textarea:focus{
        outline: none;
        border-bottom: 1px solid #6b7384 ;
    }    
`;